

export class GetEmailTemplateById implements IGetEmailTemplateById {
    id!: number;
    emailSubject!: string | undefined;
    shortCode!: string | undefined;
    emailContent!: string | undefined;
    isActive!: boolean;
    templateName!: string | undefined;

    constructor(data?: IGetEmailTemplateById) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.emailSubject = _data["emailSubject"];
            this.shortCode = _data["shortCode"];
            this.emailContent = _data["emailContent"];
            this.isActive = _data["isActive"];
            this.templateName = _data["templateName"];
        }
    }

    static fromJS(data: any): GetEmailTemplateById {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailTemplateById();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["emailSubject"] = this.emailSubject;
        data["shortCode"] = this.shortCode;
        data["emailContent"] = this.emailContent;
        data["isActive"] = this.isActive;
        data["templateName"] = this.templateName;
        return data; 
    }
}

export interface IGetEmailTemplateById {
    id: number;
    emailSubject: string | undefined;
    shortCode: string | undefined;
    emailContent: string | undefined;
    isActive: boolean;
    templateName: string | undefined;
}

